import { Modal, Button, Row, Col } from "react-bootstrap";
import { modal } from "@/utils/constant";

function ImportantModal({
  socket,
  session_id,
  hide,
  show,
  setIsButtonDisabled,
  isButtonDisabled,
}) {
  const handleStart = async () => {
    setIsButtonDisabled(true);
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    // Use socket event instead of API call
    socket.emit("game-orientation-video-start", {
      session_id: session_id,
      time_zone: timeZone,
    });
    setIsButtonDisabled(false);
    hide();
  };
  return (
    <Modal show={show} onHide={hide} size="lg" centered>
      <Modal.Header className="bg-secondary" closeButton>
        <Modal.Title>{modal?.importantModalTital}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-14">
        <p className="mb-3" style={{ textAlign: "justify" }}>
          {modal?.importantModalBody} <b>{modal?.importantModalBreakout}</b>{" "}
          {modal?.importantModalBodyText}
        </p>
        <Row className="mt-8">
          <Col xs="7">
            <Button
              variant="secondary"
              onClick={handleStart}
              className="font-semibold w-full"
              disabled={isButtonDisabled}
            >
              {modal?.importantModalButtonText}
            </Button>
          </Col>
          <Col xs="5">
            <Button
              variant="outline-primary"
              className="font-semibold w-full"
              onClick={hide}
              disabled={isButtonDisabled}
            >
              {modal?.cancle}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
export default ImportantModal;
